import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Component({
  selector: 'app-coupon-validity',
  templateUrl: './coupon-validity.component.html',
  styleUrls: ['./coupon-validity.component.css']
})
export class CouponValidityComponent implements OnInit {

  @Input() selectedCouponValidity: any;
  @Input() selectedCouponValidityValue: any;
  @Output() onInsert = new EventEmitter<any>();
  @Input() minFruitionDate: any;
  @Input() maxFruitionDate: any;
  formData: FormGroup;
  week: any[] = [];

  constructor(
    private translateService: TranslateService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.loadWeek();
    this.formData = this.fb.group({
      couponDate: ['', Validators.required]
    });
    if (this.selectedCouponValidity.param_functional_code == 'DATE') {
      this.formData.controls['couponDate'].setValue(this.selectedCouponValidityValue ? new Date(this.selectedCouponValidityValue): '')
    }
  }

  loadWeek() {
    this.week.push({label: null, value: null})
    this.week.push({label: this.translateService.instant('calendarList.monday'), value: 1})
    this.week.push({label: this.translateService.instant('calendarList.tuesday'), value: 2})
    this.week.push({label: this.translateService.instant('calendarList.wednesday'), value: 3})
    this.week.push({label: this.translateService.instant('calendarList.thursday'), value: 4})
    this.week.push({label: this.translateService.instant('calendarList.friday'), value: 5})
    this.week.push({label: this.translateService.instant('calendarList.saturday'), value: 6})
    this.week.push({label: this.translateService.instant('calendarList.sunday'), value: 7})
  }
  
  insertValue() {
    this.onInsert.emit(this.selectedCouponValidityValue)
  }

  setCouponValidityDate() {
    if (!!this.formData.get('couponDate').value) {
      this.selectedCouponValidityValue = this.formData.get('couponDate').value;
      this.insertValue();
      return this.formData.get('couponDate').value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/coupon-fruition-setup/coupon-validity/coupon-validity.component.ts